export default {
  // 电子发票航班信息
  async getInvoiceFlightInfo(params) {
    let actiontype = "getInvoiceFlightInfo";
    return await this.fetch(actiontype, params);
  },
  // 申请电子发票
  async applyInvoiceNew(params) {
    let actiontype = "applyInvoiceNew";
    return await this.fetch(actiontype, params);
  },
  // 获取我的电子发票详情
  async getMyFapiaoDetail(params) {
    let actiontype = "getMyFapiaoDetail";
    return await this.fetch(actiontype, params);
  },
  // 获取我的电子发票列表
  async getMyFapiaoList(params) {
    let actiontype = "getMyFapiaoList";
    return await this.fetch(actiontype, params);
  },
  // 云商城销售开发票 offlineShopInvoiceApply
  async getInvoiceSaleGoodsInfo(params) {
    let actiontype = "getInvoiceSaleGoodsInfo";
    return await this.fetch(actiontype, params);
  },
  // 云商城销售开发票----申请
  async offlineShopInvoiceApply(params) {
    let actiontype = "offlineShopInvoiceApply";
    return await this.fetch(actiontype, params);
  },
  // 获取发票抬头列表
  async certificatemanage_getInvoiceTitleList(params) {
    let actiontype = "certificatemanage_getInvoiceTitleList";
    return await this.fetch(actiontype, params);
  },
  // 新增发票抬头
  async certificatemanage_addInvoiceTitle(params) {
    let actiontype = "certificatemanage_addInvoiceTitle";
    return await this.fetch(actiontype, params);
  },
  // 修改发票抬头
  async certificatemanage_updateInvoiceTitle(params) {
    let actiontype = "certificatemanage_updateInvoiceTitle";
    return await this.fetch(actiontype, params);
  },
  // 删除发票抬头
  async certificatemanage_deleteInvoiceTitle(params) {
    let actiontype = "certificatemanage_deleteInvoiceTitle";
    return await this.fetch(actiontype, params);
  },
  // 重新发送
  async resendInvoice(params) {
      let actiontype = 'resendInvoice'
      return await this.fetch(actiontype, params)
  },
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/inovice.js